import { JSON_SPACE } from 'constants/json'
import { RichPlacementMultiAnchorDTO } from 'features/globalSetup/api/types/richPlacementMultiAnchorDTO'
import { RichPlacementMultiAnchor } from 'features/globalSetup/pages/Defaults/RichPlacements/hooks/useGetRichPlacementMultiAnchor'
import { WorkspaceDTO } from 'features/workspace'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export type WorkspaceDefaults = Pick<
  RichPlacementMultiAnchor,
  | 'customStyling'
  | 'displayAfterUserInteraction'
  | 'fullWidthMode'
  | 'showCloseButton'
  | 'singleAdViewTime'
>
type Data = {
  workspaceRichPlacementMultianchorConfiguration: Pick<
    RichPlacementMultiAnchorDTO,
    | 'customStyling'
    | 'displayAfterUserInteractionEnabled'
    | 'fullWidthModeEnabled'
    | 'showCloseButtonEnabled'
    | 'singleAdViewTime'
  >
}

type Variables = {
  workspaceId: WorkspaceDTO['id']
}

export const useGetWorkspaceDefaults = (): undefined | WorkspaceDefaults => {
  const { workspaceId } = useWorkspaceParam()

  const { data } = useQuery<Variables, Data, WorkspaceDefaults>({
    options: {
      select: ({ workspaceRichPlacementMultianchorConfiguration }: Data): WorkspaceDefaults => {
        const {
          customStyling,
          displayAfterUserInteractionEnabled,
          fullWidthModeEnabled,
          showCloseButtonEnabled,
          singleAdViewTime,
        } = workspaceRichPlacementMultianchorConfiguration

        return {
          customStyling: JSON.stringify(customStyling, null, JSON_SPACE),
          displayAfterUserInteraction: displayAfterUserInteractionEnabled,
          fullWidthMode: fullWidthModeEnabled,
          showCloseButton: showCloseButtonEnabled,
          singleAdViewTime,
        }
      },
    },
    query: gql`
      query getMultiAnchorWorkspaceDefaults($workspaceId: ID!) {
        workspaceRichPlacementMultianchorConfiguration(workspaceId: $workspaceId) {
          customStyling
          displayAfterUserInteractionEnabled
          fullWidthModeEnabled
          showCloseButtonEnabled
          singleAdViewTime
        }
      }
    `,
    variables: { workspaceId },
  })

  return data
}
